import React, { useCallback, useEffect, useState } from 'react';
import styles from './RecordingsVideoPreviewDialog.module.scss';
import { useTranslation } from 'react-i18next';
import CustomVideoPlayer from './CustomVideoPlayer';

interface RecordingsVideoPreviewDialogProps {
    open: boolean;
    onClose: () => void;
    title: string;
    videoUrl: string;
}

const RecordingsVideoPreviewDialog: React.FC<RecordingsVideoPreviewDialogProps> = ({
    open,
    onClose,
    title,
    videoUrl
}) => {
    const { t } = useTranslation();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleBackdropClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
        if (e.target === e.currentTarget && !isMobile) {
            onClose();
        }
    }, [onClose, isMobile]);

    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }

        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [open]);

    if (!open) return null;

    return (
        <div className={`${styles.dialogOverlay} ${isMobile ? styles.mobileOverlay : ''}`} onClick={handleBackdropClick}>
            <div className={`${styles.dialogContainer} ${isMobile ? styles.mobileContainer : ''}`}>
                <div className={`${styles.dialogHeader} ${isMobile ? styles.mobileHeader : ''}`}>
                    {!isMobile && <h2 className={styles.dialogTitle}>{title}</h2>}
                    <button
                        className={`${styles.closeButton} ${isMobile ? styles.mobileCloseButton : ''}`}
                        onClick={onClose}
                        aria-label={t('common.close')}
                    >
                        ✕
                    </button>
                </div>
                <div className={`${styles.dialogContent} ${isMobile ? styles.mobileContent : ''}`}>
                    <div className={styles.videoContainer}>
                        <CustomVideoPlayer
                            className={`${styles.video} ${styles.dialogMode}`}
                            src={videoUrl}
                            showControls={true}
                            autoPlay={true}
                            playsInline
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RecordingsVideoPreviewDialog;
